import React, { FC, useState } from "react";
import ModalPhoto from "components/ModalPhoto";

export interface Avatar2Props {
  imgUrl?: string;
  alt?: string;
  className?: string;
  imageClassName?: string;
  onImageClick?: (isOpen: boolean) => void;
}

const Avatar2: FC<Avatar2Props> = ({
  imgUrl = "",
  alt = "",
  className = "",
  imageClassName = "",
  onImageClick
}) => {
  const [modalImageUrl, setModalImageUrl] = useState<string | null>(null);

  const openModal = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (!imgUrl) return;

    setModalImageUrl(imgUrl);
    onImageClick?.(true);
  };

  const closeModal = () => {
    setModalImageUrl(null);
    onImageClick?.(false);
  };

  if (!imgUrl) return null;

  return (
    <>
      <div
        onClick={openModal}
        className={`
          relative
          overflow-hidden
          flex-shrink-0
          cursor-pointer
          shadow-md
          bg-neutral-100
          dark:bg-neutral-800
          ${className}
        `}
      >
        <img
          src={imgUrl}
          alt={alt}
          className={`
            w-full
            h-full
            object-cover
            transition-transform
            duration-300
            hover:scale-105
            ${imageClassName}
          `}
        />
      </div>

      {modalImageUrl && (
        <ModalPhoto
          imageUrl={modalImageUrl}
          onClose={closeModal}
        />
      )}
    </>
  );
};

export default Avatar2;